<p>allocation-details works!</p>
